export default "__VITE_ASSET__Bi9QMY8J__"